export enum WindowPercentageArea {
    Small = 'small',
    Medium = 'medium',
    Large = 'large'
}
